export default __webpack_public_path__ + "static/media/message.e2c19e7f.mp3";